import BaseObserver__default from 'ui-observer';
export * from 'ui-observer';
import { Component, useState, useRef, useCallback, useEffect, useMemo } from 'react';
import { findDOMNode } from 'react-dom';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var Observer = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Observer, _Component);

  function Observer() {
    var _this;

    _this = _Component.apply(this, arguments) || this;
    _this.state = {
      value: _this.props.defaultValue
    };
    _this.isMounted = false;

    _this.onChange = function (value) {
      if (!_this.isMounted) {
        return;
      }

      _this.setState({
        value: value
      });

      if (_this.props.onChange) {
        _this.props.onChange(value);
      }
    };

    return _this;
  }

  var _proto = Observer.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.isMounted = true;
    this.observer = new BaseObserver__default(this.props.value, {
      debug: this.props.debug,
      onChange: this.onChange,
      context: _extends({
        rootElement: findDOMNode(this)
      }, this.props.context)
    });
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(newProps) {
    if (this.observer) {
      this.observer.update(newProps.value);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.isMounted = false;
  };

  _proto.render = function render() {
    var children = this.props.children;

    if (typeof children === 'function') {
      return children(this.state.value);
    }

    return children;
  };

  return Observer;
}(Component);
Observer.defaultProps = {
  debug: false,
  defaultValue: false
};

var useObserver = function useObserver(value, _temp, deps) {
  var _ref = _temp === void 0 ? {} : _temp,
      context = _ref.context,
      defaultValue = _ref.defaultValue,
      debug = _ref.debug,
      rootElementRef = _ref.rootElementRef,
      onChange = _ref.onChange;

  var _useState = useState(defaultValue),
      state = _useState[0],
      setState = _useState[1];

  var observer = useRef(null);
  var onChangeRef = useRef(onChange);
  onChangeRef.current = onChange; // Handle value updates by calling onChange and/or triggering re-render.

  var onValueChange = useCallback(function (state) {
    if (onChangeRef.current) {
      onChangeRef.current(state);
    } else {
      setState(state);
    }
  }, [setState, onChangeRef]);
  useEffect(function () {
    // Create a singleton BaseObserver.
    observer.current = new BaseObserver__default(value, {
      onChange: onValueChange,
      debug: debug,
      context: _extends({
        rootElement: rootElementRef == null ? void 0 : rootElementRef.current
      }, context)
    });
    return function () {
      if (observer.current) {
        observer.current.dispose();
        observer.current = null;
      }
    };
  }, [observer]);
  useMemo(function () {
    if (observer.current) {
      // Update Observer with new context and value.
      observer.current.context = _extends({
        rootElement: rootElementRef == null ? void 0 : rootElementRef.current
      }, context);
      observer.current.update(value);
    }
  }, deps || [value, context]);
  return state;
};

export default Observer;
export { Observer, useObserver };
//# sourceMappingURL=react-ui-observer.esm.js.map
